module.exports = __webpack_public_path__ + "img/图层 32.cf2abfbf.png";